var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogFacetArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02 10c.402-.003.788-.155 1.075-.423l7.448-7.061c.292-.276.456-.65.457-1.04 0-.39-.162-.766-.452-1.042A1.596 1.596 0 0016.45 0c-.412 0-.807.154-1.099.429L9.001 6.45 2.648.429A1.612 1.612 0 001.148.05 1.514 1.514 0 00.052 1.094c-.142.509.012 1.05.405 1.422l7.448 7.06c.296.278.698.43 1.115.424z",
    fill: "#FFA700"
  })));
}
export default SvgCatalogFacetArrow;